export const authConfig = {
  domain: "unbolt.eu.auth0.com",
  clientId: "g59r8hbkoDSjHn3eDn98M3an8jmk3Do9",
};
